// extracted by mini-css-extract-plugin
export default {"container":"Leaderboard_container__+inhA","userDiv":"Leaderboard_userDiv__zqj8M","userPic":"Leaderboard_userPic__QsQU3"};